import { editorColors as colors, fonts, MERGE_TAGS } from "../../styles/theme";

export default function EditorPreview({
  previewMode,
  previewWidth,
  previewSubject,
  tenant,
  iframeRef,
  getCompiledEmailHtml,
  handleIframeLoad,
}) {
  return (
    <div
      style={{
        width: previewWidth,
        maxWidth: "100%",
        background: "#ffffff",
        borderRadius: 8,
        overflow: "hidden",
        boxShadow: "0 4px 24px rgba(0,0,0,0.12)",
        transition: "width 0.3s ease",
      }}
    >
      <div
        style={{
          padding: "16px 24px",
          background: "#f8f9fa",
          borderBottom: "1px solid #e5e7eb",
          fontSize: 13,
        }}
      >
        <div
          style={{
            display: "flex",
            gap: 8,
            marginBottom: 6,
            color: "#666",
          }}
        >
          <span style={{ fontWeight: 600, width: 50 }}>From:</span>
          <span>
            {tenant.companyName}
            &lt;{tenant.fromEmail}&gt;
          </span>
        </div>
        <div
          style={{
            display: "flex",
            gap: 8,
            marginBottom: 6,
            color: "#666",
          }}
        >
          <span style={{ fontWeight: 600, width: 50 }}>To:</span>
          <span>Sarah Chen &lt;s.chen@meridianfund.com&gt;</span>
        </div>
        <div style={{ display: "flex", gap: 8, color: "#111" }}>
          <span style={{ fontWeight: 600, width: 50, color: "#666" }}>
            Subj:
          </span>
          <span style={{ fontWeight: 600 }}>
            {previewSubject || "(no subject)"}
          </span>
        </div>
      </div>
      <iframe
        ref={iframeRef}
        srcDoc={getCompiledEmailHtml()}
        onLoad={handleIframeLoad}
        sandbox="allow-same-origin"
        title="Email Preview"
        style={{
          width: "100%",
          minHeight: 400,
          border: "none",
          background: "#ffffff",
          display: "block",
        }}
      />
    </div>
  );
}
